export const Hero = () => {
    return (
        <div className='bg-main'>
            <div className='max-w-[1800px] mx-auto relative'>
                <div
                    className='w-full absolute top-[70vw] left-1/2 -translate-x-1/2
         md:top-[200px] md:-translate-x-1/4 md:left-1/4 lg:left-4'
                >
                    <div className='mx-auto md:mx-0 lg:mx-auto w-full md:w-[44vw] lg:w-[54vw] md:max-w-[600px] lg:max-w-[760px] relative'>
                        <div>
                            <img
                                className='w-full drop-shadow-2xl'
                                src={`${process.env.PUBLIC_URL}/images/PB_TheLastHero_Logo_Small.webp`}
                                alt='Phantom brave logo'
                            />{' '}
                        </div>
                        {/* <h1 className='text-center font-sans herotext text-gradient'>Sortie en 2025 !</h1>  */}
                        <h1 className='text-center font-sans herotext text-gradient'>Disponible maintenant</h1>{' '}
                    </div>{' '}
                </div>
                <div className='hidden md:block'>
                    <div className='absolute flex flex-col md:flex-row top-1 items-center right-1 md:top-32 md:right-5 lg:top-32 lg:right-10 bg-pbyellow border-pbnavy border-3 md:border-4  text-pbnavy font-sans text-sub md:gap-2 rounded-lg'>
                        <div className='bg-pbnavy text-pbyellow w-full'>
                            <p className='my-1 md:my-2 mx-2 md:mx-4 '>Textes </p>
                        </div>
                        <div className='relative w-full '>
                            <div className='w-full text-pbnavy hover:text-pborange py-1 md:py-2 px-1 md:px-2 text-center'>
                                <a href='https://nisamerica.com/phantombrave-the-lost-hero'>English</a>{' '}
                            </div>
                        </div>
                        <div className='w-full text-pborange py-1 md:py-2 px-1 md:pr-4 text-center'>
                            <p>Français</p>{' '}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
